import { render } from "./ListeVesselPage.vue?vue&type=template&id=065a6c04&ts=true"
import script from "./ListeVesselPage.vue?vue&type=script&lang=ts"
export * from "./ListeVesselPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__